import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import termApi from "../../api/Terms";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TermTable from "../../components/tables/primeTable/term/TermTable";

const Terms = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [termData, setTermData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // fetch terms
    try {
      getTerms();
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load terms. Please try again later."
      );
      if (!empty(location) && !empty(location.state)) {
        navigate(null, {
          replace: true,
          state: { termsAdded: false, termUpdated: false },
        });
      }
    }
  }, []);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // function to get all terms
  const getTerms = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId =
        !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
      const response = await termApi.getTerms(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setTermData([]);
      } else {
        setTermData(response_data.response);
      }

      // check if a new term was added
      if (location.state !== null) {
        const paramState = !empty(location.state) ? location.state : {};
        const termAdded = !empty(paramState.termAdded)
          ? paramState.termAdded
          : false;
        const termUpdated = !empty(paramState.termUpdated)
          ? paramState.termUpdated
          : false;
        if (termAdded === true || termUpdated === true) {
          const actionType = termAdded ? "added" : "updated";
          responseDialog(
            "success",
            "Success",
            `Term ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: { termAdded: false, termUpdated: false },
            });
          }
        }
      }
    } catch (error) {
      responseDialog("error", "Error Alert", `Something went wrong.`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader title="Terms" />
            {/* end of header */}

            {/* table start */}
            <TermTable terms={termData} />
            {/* table end  */}
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
      </AppWrapper>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default Terms;
